export default "__VITE_ASSET__DlrcL_dR__"